// extracted by mini-css-extract-plugin
export default {"card":"x3-z"};